import { createFileRoute, redirect } from '@tanstack/react-router'
import type { PaymentsSection } from '@/components/settings/payments-sidebar'

export const Route = createFileRoute('/_app/_settings/disputes')({
  beforeLoad: () => {
    throw redirect({ to: '/payments', search: { section: 'disputes' as PaymentsSection } })
  },
})
